import React, { useEffect, useState } from 'react';
import { Selector } from 'react-gldn-kit';
import {
  PaymentChannelType,
  UserInfo,
} from 'react-memory-optimization/dist/lib/store/user/types';
import { useUserInfo } from 'react-render-hooks';

import depositStyles from '../../Deposit.module.css';
import { useZustandPaymentsStore } from 'stores/money/payments/store';
import { setPaymentsCurrentStepAction } from 'stores/money/payments/selectors';
import { setFormsInfoAction } from 'stores/money/forms/selectors';
import { useZustandFormsStore } from 'stores/money/forms/store';
import { useZustandUserStore } from 'stores/user/personal/store';
import { getUserCurrencyIdSelector } from 'stores/user/personal/selectors';
import { DEFAULT_INPUT_VALUE } from 'components/ui/Input/Base/constant';
import { DefaultInputType } from 'components/ui/Input/Base/types';
import { useHookFabric } from 'hooks/useHookFabric';
import { isFilledForm } from 'utils/validation';
import AmountInput from 'components/ui/Input/AmountInput';
import PhoneInput from 'components/ui/Input/Phone';
import Input from 'components/ui/Input/Base';
import { BANK_CODE } from './constants';
import PortalList from '../../../PortalList';
import { Steps } from 'stores/money/payments/types';
import { ERequestIds } from 'react-memory-optimization/dist/lib/binary/types';

type Props = {
  limit: { min: number; max: number };
  activeChannelId:
    | PaymentChannelType.APayJazzcashP2C
    | PaymentChannelType.APayNayapayP2P
    | PaymentChannelType.APayBankalfalahP2C;
};

const APayPkr = (props: Props) => {
  const { limit, activeChannelId } = props;

  const [amount, setAmount] = useState<string>('');

  const [transaction, setTransaction] = useState<string>('');

  const currencyId = useZustandUserStore(getUserCurrencyIdSelector);

  const setFormInfo = useZustandFormsStore(setFormsInfoAction);

  const setStep = useZustandPaymentsStore(setPaymentsCurrentStepAction);

  useEffect(() => {
    const data = [amount];

    const isFilled = isFilledForm(data);

    if (isFilled && currencyId) {
      setFormInfo({
        isDeposit: true,
        form: {
          amount,
          channelId: activeChannelId,
          transaction: '',
          currencyId,
          requestId: ERequestIds.RequestDeposit,
        },
      });
      setStep(Steps.FilledForm);
    } else {
      setStep(Steps.TypingData);
    }
  }, [currencyId, amount]);

  return (
    <>
      <AmountInput
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        placeholder="walletPopUp.forms.amount"
        size="full"
        onChange={setAmount}
        min={limit.min}
        max={limit.max}
        classes={depositStyles.amountInputMargin}
        wrapperClasses={depositStyles.marginInputBottom}
      />

      {/* <Input
        placeholder="walletPopUp.forms.transaction"
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        size="full"
        classes={depositStyles.marginInputBottom}
        // errorText={transaction.errorText}
        onChange={setTransaction}
      /> */}
    </>
  );
};

export default APayPkr;
